import styled from 'styled-components';
import { openSansBold, tekoSemibold } from '../../../utils/theme';
import { mobile, tablet } from '../../../utils/breakpoints';

const HEIGHT = 'auto';
const WIDTH = '100%';

export const VideoCotainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  &.not-fullBleed {
    max-width: 1200px;
    margin: 80px auto;
  }
`;

export const VideoModal = styled.div`
  position: absolute;
  z-index: 1000;
  background: white;
  width: 90%;
  height: 90%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  max-height: ${HEIGHT};
  max-width: ${WIDTH};

  button {
    display: block;
    background: transparent;
    border: none;
    margin: 15px;

    &:hover {
      cursor: pointer;
    }
  }

  img {
    width: 100%;
    height: auto;
  }

  iframe {
    left: 10%;
    top: 10%;
    max-height: 80%;
    max-width: 80%;
    position: absolute;
  }
  @media (max-width: 1400px) {
    iframe {
      width: 100vw;
      height: 56.25vw;
    }
  }
`;

export const VideoInner = styled.div`
  width: 100%;
  margin: 0 auto;
  position: relative;
  display: flex;
  max-height: ${HEIGHT};
  max-width: ${WIDTH};
  ${({ hideOverlay }) => (hideOverlay
    ? ''
    : `&:before {
    content: '';
    background-image: linear-gradient(270deg, rgba(0, 0, 0, 0) 24%, #000000 100%);
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
  }`)} &.hide {
    &:before {
      display: none;
    }
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  position: absolute;
  padding: 58px 45px 0 45px;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  transition: all 150ms ease-out;
  text-align: center;
  height: 100%;

  @media(max-width: ${tablet.max}px) {
    padding: 39px 20px;
  }

  @media(max-width: ${mobile.max}px) {
    padding: 12px 20px;
  }

  &.hide {
    opacity: 0;
    z-index: -1;
  }

  h2 {
    ${tekoSemibold} font-size: 100px;
    color: #ffffff;
    letter-spacing: 8px;
    line-height: 75px;
    margin: 15px 0 18px 0;
    position: relative;
    text-align: center;
    -ms-transform: skewX(-10deg); /* IE 9 */
    -webkit-transform: skewX(-10deg); /* Safari */
    transform: skewX(-10deg);
    @media(max-width: ${tablet.max}px) {
      margin-bottom: 9px;
      font-size: 75px;
      line-height: 65px;
    }

    @media(max-width: ${mobile.max}px) {
      font-size: 38px;
      line-height: 30px;
      letter-spacing: 3.5px;
      margin-bottom: 4px;
    }
  }

  p {
    ${openSansBold};
    text-transform: uppercase;
    font-size: 20px;
    color: #ffffff;
    letter-spacing: 5px;
    line-height: 17px;
    margin: 0 0 20px 0;
    text-align: center;

    @media(max-width: ${mobile.max}px) {
      font-size: 16px;
      margin: 0 0 5px 0;
      letter-spacing: 2px;
    }
  }

  .play-icon {
    display: block;
    z-index: 3;
    width: 150px;
    height: 150px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;

    @media (max-width: ${mobile.max}px) {
      width: 55px;
      height: 55px;
    }

  }
`;

export const VideoWrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  position: relative;
  
  &:after {
    content: '';
    display: block;
    padding-bottom: 56.25%;
  }

  iframe {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .playButton {
    cursor: pointer;
    background: transparent;
    outline: none;
    border: none;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 150px;
    height: 150px;
    transform: translate(-50%, -50%);
    z-index: 3;

    @media (max-width: ${mobile.max}px) {
      width: 55px;
      height: 55px;
      padding: 0;
    }
  }
  
  .poster-image-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    
    &.is-visible {
      cursor: pointer;
      transition: all 0.25s ease;
    }
    &.is-hidden {
      opacity: 0;
      pointer-events: none;
      transition: all 0.75s ease;
    } 
  }

  img {
    width: 100%;
    height: auto;
  }
`;

export const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  left: 0;
  top: 0;
  cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/components/video/styles/video.style.js